<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="col-md-12">
  <fieldset *ngIf="isWorldPay() || isInstaMed()">
    <legend class="row">
      <div class="col-md-6 m-auto">Rates and Contract Information</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary float-right"
          *ngIf="
            merchant.contractedRates &&
            hasFinanceRole() &&
            isMerchantActive() &&
            !editable
          "
          (click)="this.editable = true"
        >
          <span *ngIf="hasContractedRates(); else adIcon">
            <fa-icon [icon]="faEditPencil"></fa-icon>
          </span>
          {{
            hasContractedRates()
              ? "Edit Rates and Contract Information"
              : "Add Rates and Contract Information"
          }}
          <ng-template #adIcon>
            <span>
              <fa-icon [icon]="faPlus"></fa-icon>
            </span>
          </ng-template>
        </button>
      </div>
    </legend>

    <div class="mt-3" *ngIf="!editable">
      <div class="row" *ngIf="!merchant.contractedRates">
        <div class="col-md-12">
          <span class="row recordRow">
            Rates and Contract information have not been added.
          </span>
        </div>
      </div>

      <div class="row" *ngIf="merchant.contractedRates">
        <div class="col-md-12">
          <div class="table-block">
            <div class="recordRow">
              <div class="recordLabel" *ngIf="!isInstaMed()">
                Per Trans Auth Fee
              </div>
              <div class="recordLabel" *ngIf="isInstaMed()">
                Per Credit Card Trans Fee
              </div>
              <div id="platformFeeAuth" class="recordValue">
                {{ merchant.contractedRates.perTransAuthFee / 100 | currency }}
              </div>
            </div>

            <div class="recordRow" *ngIf="isInstaMed()">
              <div class="recordLabel">Per eCheck Trans Fee</div>
              <div id="platformECheck" class="recordValue">
                {{
                  merchant.contractedRates.perTransECheckFee / 100 | currency
                }}
              </div>
            </div>

            <div class="recordRow" *ngIf="!isInstaMed()">
              <div class="recordLabel">Per Trans Refund Fee</div>
              <div id="platformFeeRefund" class="recordValue">
                {{
                  merchant.contractedRates.perTransRefundFee / 100 | currency
                }}
              </div>
            </div>
            <div
              class="recordRow"
              *ngIf="merchant.contractedRates && !isInstaMed()"
            >
              <div id="feeSettlement" class="recordLabel">Fee Settlement</div>
              <div class="recordValue">
                {{
                  merchant.contractedRates.suppressFeeSettlement
                    ? "Monthly"
                    : "Daily"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <legend *ngIf="merchant.contractedRates" class="borderDivide mt-5">
        <div class="borderSeparation">Percentage Fee Tiers</div>
      </legend>
      <div class="row mt-3" *ngIf="merchant.contractedRates">
        <div class="col-md-10">
          <table class="table table-bordered table-condensed table-striped">
            <thead>
              <tr>
                <th>Tier</th>
                <th *ngIf="!isInstaMed()">Upper Boundary</th>
                <th>Fee Percentage (%)</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td *ngIf="!isInstaMed()">Qualified</td>
                <td *ngIf="isInstaMed()">Card Present</td>
                <td id="qTierBoundary" *ngIf="!isInstaMed()">
                  {{ merchant.contractedRates.qualifiedUpperBoundaryPercent }}
                </td>
                <td id="qTierFee">
                  {{ merchant.contractedRates.qualifiedFeePercent }}
                </td>
              </tr>
              <tr>
                <td *ngIf="!isInstaMed()">Mid-Qualified</td>
                <td *ngIf="isInstaMed()">Card Not Present</td>
                <td id="mQTierBoundary" *ngIf="!isInstaMed()">
                  {{
                    merchant.contractedRates.midQualifiedUpperBoundaryPercent
                  }}
                </td>
                <td id="mQTierFee">
                  {{ merchant.contractedRates.midQualifiedFeePercent }}
                </td>
              </tr>
              <tr *ngIf="!isInstaMed()">
                <td>Non-Qualified</td>
                <td id="nQTierBoundary" *ngIf="!isInstaMed()">
                  {{
                    merchant.contractedRates.nonQualifiedUpperBoundaryPercent
                  }}
                </td>
                <td id="nQTierFee">
                  {{ merchant.contractedRates.nonQualifiedFeePercent }}
                </td>
              </tr>
              <tr>
                <td>American Express</td>
                <td id="amexTier" *ngIf="!isInstaMed()">N/A</td>
                <td id="amexFee">{{ merchant.contractedRates.amexPercent }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-3" *ngIf="editable">
      <form
        name="generalInfoFormControl"
        class="form-horizontal"
        novalidate
        [formGroup]="ratesFormGroup"
        (submit)="saveRates()"
      >
        <app-edit-rates-and-contract
          [parentGroup]="ratesFormGroup"
          [isInstaMed]="isInstaMed()"
          [updateMode]="hasContractedRates()"
          [amexFeeRequired]="isAmexFeeRequired()"
        >
        </app-edit-rates-and-contract>
        <app-edit-buttons
          [buttonName]="buttonName"
          [actionInProgress]="actionInProgress"
          [formInvalid]="ratesFormGroup.invalid"
          (editableEvent)="receiveEditEvent($event)"
        ></app-edit-buttons>
      </form>
    </div>
  </fieldset>
</div>
